fragment BehaviorFragment on ChatSettings {
    chatbot {
        responseTiming
        name
        iconEnum
        tone
        answerLength
        suggestions
        topicsToAvoid
    }
    offline {
        isEnabled
        form {
            id
            publicFormId
            name
            htmlUrlPath
            lastSubmittedTime
            numSubmissions
        }
        formType
        message
        conversationalMessage
    }
    assignment {
        strategy
        user {
            id
        }
    }
    lookAndFeel {
        color
        nameDisplay
        nudgeSettings {
            isEnabled
            message
        }
        icon {
            type
            url
        }
        conversationStarter
        showPoweredBy
        disclaimerSettings {
            isEnabled
            message
        }
    }
}
